/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// `/seguranca` abre Usuários, como o índice do legado (router.tsx:1951).
export const Route = createFileRoute('/_app/seguranca/')({
  beforeLoad: () => {
    throw redirect({ to: '/seguranca/usuarios', replace: true });
  },
});
